import { RootContainer } from '../../../../core/root_container';
import { SearchTotalItemAction } from '../../actions/search_total_item_action';
import { KeywordDetailJsEnv } from '../../models/keyword_detail_js_env';
import { SearchErrorArea } from './search_condition';

export class SearchWordConditionContainer extends RootContainer<KeywordDetailJsEnv> {
  constructor(model: KeywordDetailJsEnv) {
    super();
    this.mount(SearchErrorArea, 'warning');

    // 初回描画
    this.update(model);

    SearchTotalItemAction.UPDATE_EVENT.on((model: KeywordDetailJsEnv) => {
      this.update(model);
    });
  }
}
